import AsyncStorage from "@react-native-async-storage/async-storage";
import { LinearGradient } from 'expo-linear-gradient';
import React, { useEffect, useState } from 'react';
import { Linking, ScrollView, Text, TouchableOpacity, View } from 'react-native';
import { FormattedMessage } from 'react-intl';

import HeaderTabs from '../../components/HeaderTabs';
import styles from './styles';
const LevelUpdate = () => {
  const emailPJ = 'verificacao.pj@gpxtecinvest.com.br'
  const emailPF = 'verificacao.pf@gpxtecinvest.com.br'
  const [userType, setUserType] = useState('')
  const [email, setEmail] = useState('')

  useEffect(() => {
    async function getUserType() {
      const user = await AsyncStorage.getItem("usertype");
      setUserType(user)
      setEmail(userType == 'PJ' ? emailPJ : emailPF)
    }
    getUserType()
  }, [])
  return (<>
    <HeaderTabs
      title={<FormattedMessage id="levelUpdate.headerTitleMinhaQualificacao"/>}
      subtitle={<FormattedMessage id="levelUpdate.headerSubTitle"/>}
    />
    <ScrollView>
      <View style={styles.text}>
        {userType == 'PJ' ?
          <>
            <Text style={styles.bold}><FormattedMessage id="levelUpdate.txtPessoaJuridica"/></Text>
            <Text style={{fontWeight: 'bold'}}><FormattedMessage id="levelUpdate.txtEnvieDocsNecessarios"/></Text>
            <Text style={styles.list}>
              <FormattedMessage id="levelUpdate.txtComprovanteEnderecoAdm"/>{'\n'}
              <FormattedMessage id="levelUpdate.txtDocIdentidadeAdm"/>{'\n'}
              <FormattedMessage id="levelUpdate.txtSelfieAdm"/>
              
            </Text>
            <Text style={{fontWeight: 'bold'}}>
              <FormattedMessage id="levelUpdate.txtAtingirNivel3Docs"/>{'\n'}
            </Text>
            <Text><FormattedMessage id="levelUpdate.txtLtda"/></Text>
            <Text style={styles.list}>
            <FormattedMessage id="levelUpdate.txtContratoSocial"/>{'\n'}
            <FormattedMessage id="levelUpdate.txtUltimaAlteracaoContratual"/>{'\n'}
            <FormattedMessage id="levelUpdate.txtCartaoCnpj"/>
            </Text>
            <Text><FormattedMessage id="levelUpdate.txtSaOuCooperativa"/></Text>
            <Text style={styles.list}>
            <FormattedMessage id="levelUpdate.txtEstatutoSocial"/>
            </Text>
            <Text style={styles.bold}><FormattedMessage id="levelUpdate.txtDocsAmbosTipos"/></Text>
            <Text style={styles.list}>
            <FormattedMessage id="levelUpdate.txtFaturamentoGerencial"/>{'\n'}
            <FormattedMessage id="levelUpdate.txtBalancosBalancete"/>{'\n'}
            <FormattedMessage id="levelUpdate.txtDadosBancarios"/>{'\n'}
            <FormattedMessage id="levelUpdate.txtDocsSociosAvalistas"/>{'\n'}
            <FormattedMessage id="levelUpdate.txtDadosBancariosCorrente"/>{'\n'}
            <FormattedMessage id="levelUpdate.txtComprovanteResidencia"/>{'\n'}
            <FormattedMessage id="levelUpdate.txtContatoResponsavel"/>{'\n'}
            <FormattedMessage id="levelUpdate.txtDescricaoAtividades"/>
            </Text>
            <Text style={styles.bold}><FormattedMessage id="levelUpdate.txtDadosTradeResponsavel"/></Text>
            <Text style={styles.list}>
            <FormattedMessage id="levelUpdate.txtDocumentos"/>
            <FormattedMessage id="levelUpdate.txtCartaAutorizacao"/>
            <FormattedMessage id="levelUpdate.txtDescritivoValoresTransacionados"/>{'\n'}
            <FormattedMessage id="levelUpdate.txtCartaAutorizacaoSociosPoderes"/>{'\n'}
            <FormattedMessage id="levelUpdate.txtDescritivoValoresTransacionados"/>{'\n'} 
            </Text>
          </>
          :
          <>
            <Text style={styles.bold}><FormattedMessage id="levelUpdate.txtPessoaFisica"/></Text>
            <Text style={{fontWeight: 'bold'}}><FormattedMessage id="levelUpdate.txtEnvieDocsNecessarios"/></Text>
            <Text style={styles.list}>
            <FormattedMessage id="levelUpdate.txtPfComprovanteEndereco"/>{'\n'}
            <FormattedMessage id="levelUpdate.txtPfDocsIdentificacao"/>{'\n'}
            <FormattedMessage id="levelUpdate.txtPfSelfie"/>
            </Text>
            <Text style={{fontWeight: 'bold'}}><FormattedMessage id="levelUpdate.txtAtingirNivel3Docs"/></Text>
            <Text style={styles.list}><FormattedMessage id="levelUpdate.txtDocsNivel3"/>
            </Text>
          </>
        }
        <View style={styles.contentBtn}>
          <TouchableOpacity 
            onPress={() => Linking.openURL(`mailto:${email}`)} 
            title={email}
            style={styles.btn}>
              <Text style={styles.textBtn}>
                <FormattedMessage id="levelUpdate.txtIrParaEmail"/>
              </Text>
          </TouchableOpacity>
        </View>
      </View>

    </ScrollView>
  </>

  )
}
export default LevelUpdate